import React, { memo, useMemo } from 'react';
import { isTruthy } from 'utility/functions';
import { SportsPiuGiocateTabDto, SportsPointerAvvenimentoDto } from 'types/swagger';
import { shallowEqual } from 'fast-equals';
import { ManifestationeContent } from './ManifestationeIContent';

export interface TabContentProps {
  tab: SportsPiuGiocateTabDto;
  keys: Array<string | undefined>;
  isNotTopTemplate?: boolean;
  infoTipoScommessaIndex: number;
  infoTipoScommesseKeyListTab: Array<string>;
}

export const TabContent = memo(
  function TabContent({
    tab,
    keys,
    isNotTopTemplate,
    infoTipoScommessaIndex,
    infoTipoScommesseKeyListTab,
  }: TabContentProps) {
    // Memoize the avvenimenti arrays to prevent recreating them on each render
    const memoizedContentTabList = useMemo(() => {
      return (tab?.contentTabList || []).filter((x) => {
        const lst = x?.avvenimentoList?.filter(
          (el, idx, lst) => idx === lst.findIndex((tmp) => tmp.key === el.key) && keys?.includes(el.key)
        );
        return isTruthy(lst?.length);
      });
    }, [keys, tab?.contentTabList]);

    return (
      <React.Fragment key={`tab-content-${tab.idTab}`}>
        {memoizedContentTabList.map((manifestazione, indexManifestazione) => {
          const avvenimenti: Array<SportsPointerAvvenimentoDto> = (manifestazione?.avvenimentoList ?? [])
            .filter((el, idx, lst) => idx === lst.findIndex((tmp) => tmp.key === el.key) && keys?.includes(el.key))
            .map(({ key, firstPriority }) => ({ key, firstPriority } as SportsPointerAvvenimentoDto));

          return (
            <ManifestationeContent
              key={`${manifestazione.idGruppo}-${manifestazione.idManifestazione}-${indexManifestazione}`}
              isFirst={indexManifestazione < 1}
              avvenimenti={avvenimenti}
              manifestazione={manifestazione}
              isNotTopTemplate={isNotTopTemplate}
              indexManifestazione={indexManifestazione}
              infoTipoScommessaIndex={infoTipoScommessaIndex}
              infoTipoScommesseKeyListTab={infoTipoScommesseKeyListTab}
            />
          );
        })}
      </React.Fragment>
    );
  },
  (prevProps, nextProps) =>
    prevProps.isNotTopTemplate === nextProps.isNotTopTemplate &&
    prevProps.infoTipoScommessaIndex === nextProps.infoTipoScommessaIndex &&
    shallowEqual(prevProps.tab, nextProps.tab) &&
    shallowEqual(prevProps.keys, nextProps.keys) &&
    shallowEqual(prevProps.infoTipoScommesseKeyListTab, nextProps.infoTipoScommesseKeyListTab)
);
